/** slug → BQ unified_requests.service_name の表示値（JOIN キー）。 @graph-connects none */
export const SERVICE_SLUG_TO_NAME = {
    aircloset: 'airCloset',
    dress: 'Dress',
    mall: 'aC MALL',
    bridge: 'Bridge',
    mens: 'Mens',
    // phoenix は他サービスと同じ TitleCase 正規化名。unified_requests VIEW の phoenix ブランチが emit する
    // service_name（'Phoenix'）と一致させる（app↔BQ ミラーの JOIN キー。ずれると WHERE service_name 一致が空振る）。
    phoenix: 'Phoenix',
};
/** BQ service_name → slug（表示文字列からの逆引き）。 @graph-connects none */
export const SERVICE_NAME_TO_SLUG = Object.fromEntries(Object.entries(SERVICE_SLUG_TO_NAME).map(([slug, name]) => [name, slug]));
/**
 * 全 slug のリテラルタプル（絞り込みの選択肢順）。zod の `z.enum` は readonly タプルを要求するため、
 * `Object.keys` 由来の `string[]` ではなくこちらを渡す。`SERVICE_SLUG_TO_NAME` との過不足は
 * services.test.ts が機械的に突き合わせる（片方だけサービスを足したら落ちる）。
 * @graph-connects none
 */
export const OPS_SERVICE_SLUG_VALUES = [
    'aircloset',
    'dress',
    'mall',
    'bridge',
    'mens',
    'phoenix',
];
/** 全 slug（絞り込みの選択肢順）。 @graph-connects none */
export const OPS_SERVICE_SLUGS = [...OPS_SERVICE_SLUG_VALUES];
/** slug → UI 表示ラベル。 @graph-connects none */
export const OPS_SERVICE_LABELS = {
    aircloset: 'airCloset',
    dress: 'Occasion Dress',
    mall: 'aC MALL',
    bridge: 'Bridge',
    mens: "airCloset Men's",
    phoenix: 'Phoenix',
};
//# sourceMappingURL=services.js.map